
























import { MessageDialog } from '../../../utils/MessageDialog';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CommonCalendar, { CalendarEvent, DateClickEvent, LessonStatesColor } from '../../../components/organisms/CommonCalendar.vue';
import { Session } from '../../../utils/Session';
import { DT_FORMAT, dayjs, DT_FORMAT_INPUT } from '../../../../src_server/common/momentExtends';
import { TimeGridView } from '@fullcalendar/timegrid';
import { LessonsService } from '../../../biz/remote/LessonsService';
import { LessonDTO } from '../../../../src_server/entity/dto/LessonDTO';
import { LessonStates } from '../../../../src_server/entity/master/LessonStates';
import DaCalssCalendarDialog from './DaCalssCalendarDialog.vue';

@Component({ components: { CommonCalendar, DaCalssCalendarDialog } })
export default class DaClassCalendarPage extends Vue {
  @Prop({ default: '' })
  private selectedTeacherId!: string;

  @Prop({ default: '' })
  private selectedTeacherNickName!: string;

  private initCalendarView = 'dayGridMonth';

  private displayTerm: { start: Date; end: Date } = { start: new Date(), end: new Date() };
  private lessonList: CalendarEvent[] = [];

  @Prop({ default: [] })
  private classes!: { title: string; value: string }[];

  private isEditable = false;

  get title() {
    return `${this.selectedTeacherNickName}の状況カレンダー`;
  }

  @Watch('selectedTeacherId')
  setSelectedTeacher(value: string) {
    // カレンダー表示をリロード
    this.loadCalendarEvents(this.displayTerm.start, this.displayTerm.end);
  }

  /**
   * 表示している領域が変更になった時
   */
  async datesRender(view: TimeGridView, el: any) {
    // console.log('datesRender', view);
    await this.showCalendarEvents(view);
  }

  /**
   * イベントをクリックした時
   */
  private eventClick(e: DateClickEvent) {
    (this.$refs['DaCalssCalendarDialog'] as DaCalssCalendarDialog).show(parseInt(e.event?.id as string));
  }

  /**
   * ドラッグで移動した時
   */
  async eventResizeAndDrop(schedule_id: number, start: Date | null, end: Date | null) {
    await MessageDialog.alert(`ドラッグ不能です`);
  }

  /**
   * カレンダーのイベントを表示します。（カレンダーのdatesRenderイベントで実行）
   * 表示期間を切り替えると発生する
   */
  async showCalendarEvents(event: any) {
    const start = event.view.activeStart;
    const end = event.view.activeEnd;
    this.displayTerm = { start: start, end: end };
    // console.log('cal ', start, end);
    this.loadCalendarEvents(start, end);
  }

  async loadData() {
    await this.loadCalendarEvents(this.displayTerm.start, this.displayTerm.end);
  }

  async loadCalendarEvents(start: Date, end: Date) {
    const biz = new LessonsService();
    if (this.selectedTeacherId === 'all') {
      const result = await biz.getLessonDtoByBuilding(Session.getSessionBuildingId(), dayjs(start).format(DT_FORMAT_INPUT), dayjs(end).format(DT_FORMAT_INPUT));
      this.convertCalendarEvent(result.data);
    } else {
      const result = await biz.getLessonDtoByTeacherId(this.selectedTeacherId, dayjs(start).format(DT_FORMAT_INPUT), dayjs(end).format(DT_FORMAT_INPUT));
      this.convertCalendarEvent(result.data);
    }
  }

  /**
   * レッスンからカレンダーイベントへ変換
   */
  convertCalendarEvent(value: LessonDTO[]) {
    this.lessonList = value.map((dto): CalendarEvent => {
      const title = `${dto.student?.full_name}:${dto.lessons.reservation_state}`;
      console.log(dto.lessons.class_id);
      const event = {
        title: title,
        start: dayjs(dto.lessons.start_dt).format(DT_FORMAT),
        end: dayjs(dto.lessons.end_dt).format(DT_FORMAT),
        backgroundColor: LessonStatesColor.getColor(dto.lessons.reservation_state!),
        id: dto.lessons.class_id,
        classNames: [LessonStates.getStateCode(dto.lessons.reservation_state!)],
      } as CalendarEvent;
      return event;
    });
  }
}
